import { Workbook } from "exceljs";
import { Button } from "antd";
import { useSelector } from "react-redux";
import * as fs from "file-saver";

const DownLoadExcelTemplate = () => {
  const taxList = useSelector((state) => state.taxList.taxList);
  const generateExcel = async () => {
    let taxNameArray = taxList?.map((value) => {
      return value.taxName;
    });
    console.log("taxNameArray", taxNameArray);

    let header = [
      "group",
      "category",
      "subCategory",
      "productBrand",
      "productName",
      "productMrp",
      "productPrice",
      "measurement Value",
      "measurement Unit",
      "inventoryQty",
      "lowStockAlert",
      "productEANCode",
      "purchasePrice",
      "productCode",
      "productTax",
      "taxIncExc",
      "productHsnCode",
      "productImageArray",
    ];

    //Create workbook and worksheet
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet("Add product for vendor bill");

    //Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        bgColor: { argb: "ef4667" },
        fgColor: { argb: "ef4667" },
      };

      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
        bgColor: { argb: "ef4667" },
      };
    });

    for (var i = 1; i <= header.length; i++) {
      const dobCol = worksheet.getColumn(i);
      dobCol.width = 22;
    }
    worksheet.getRow(1).font = {
      family: 4,
      size: 16,
      color: { argb: "FFFFFF" },
    };
    worksheet.dataValidations.add("O2:O9999", {
      type: "list",
      allowBlank: false,
      formulae: [`"${taxNameArray.toString()}"`],
      showErrorMessage: true,
      errorStyle: "error",
      error:
        "Entered tax name is not available,please add the tax in taxmaster and download the latest excel template for products upload.",
    });
    worksheet.dataValidations.add("P2:P9999", {
      type: "list",
      allowBlank: false,
      formulae: ['"inclusive,exclusive"'],
      showErrorMessage: true,
      errorStyle: "error",
      error: "The select any one tax type",
    });
    //Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fs.saveAs(blob, "productUploadTemplate.xlsx");
    });
  };
  return (
    <Button ghost type="primary" onClick={() => generateExcel()}>
      Download Template
    </Button>
  );
};

export default DownLoadExcelTemplate;
